import { render, staticRenderFns } from "./BlogBackButton.vue?vue&type=template&id=6b8f3269&scoped=true&"
import script from "./BlogBackButton.vue?vue&type=script&lang=js&"
export * from "./BlogBackButton.vue?vue&type=script&lang=js&"
import style0 from "./BlogBackButton.vue?vue&type=style&index=0&id=6b8f3269&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8f3269",
  null
  
)

export default component.exports